import { memo, useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { StyledTab } from './styles';
import { SearchCategory } from './core/search-use-case';

interface IPros {
  selectedTab: string;
  onTabChange: (tab: string) => void;
  categories: SearchCategory[];
  children: React.ReactNode;
}

export const Tabs = memo<IPros>(
  ({ onTabChange, selectedTab, categories, children }) => {
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
      onTabChange(newValue);
    };

    return (
      <>
        <Box sx={{ width: '100%' }}>
          <TabContext value={selectedTab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList
                onChange={handleChange}
                aria-label="Categorias dos ativos"
                TabIndicatorProps={{ hidden: true }}
                sx={{
                  minHeight: 'auto',
                  py: 1,
                }}
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
                TabScrollButtonProps={{
                  sx: {
                    '&.Mui-disabled': {
                      display: 'none',
                    },
                  },
                }}
              >
                {categories.map((item) => (
                  <StyledTab
                    key={item.slug}
                    label={item.label}
                    value={item.slug}
                  />
                ))}
              </TabList>
            </Box>

            <Box sx={{ maxHeight: 400, overflowY: 'auto' }}>{children}</Box>
          </TabContext>
        </Box>
      </>
    );
  }
);
